import React from "react";
import Typography from "./ui/Typography";
import BrandMark from "./BrandMark";
import { openConsentPreferences } from "../utils/analytics";
import { COVERAGE_COUNTRIES } from "../utils/coverage";
import { formatMonthLabel } from "../pages/month/monthSeo";

import { getBuildDate, getLatestBestOfYearMonth } from "../utils/bestOfMonth";

const SiteFooter = () => {
    const year = getBuildDate().getUTCFullYear();
    const bestOfYearMonth = getLatestBestOfYearMonth();

    return (
        <footer className="site-footer">
            <div className="site-footer__pattern hero-atom-pattern" aria-hidden="true" />
            <div className="site-footer__grain hero-atom-grain" aria-hidden="true" />
            <div className="site-footer__film" aria-hidden="true" />
            <div className="site-footer__inner">
                <div>
                    <div className="site-footer__brand-row">
                        <BrandMark href="/" showWordmarkOnPhones />
                    </div>
                        <Typography
                            variant="body-large"
                            className="site-footer__desktop-summary summary-copy summary-copy--left text-body sm:text-body md:text-body-large"
                        >
                            New and returning TV worth your time, and what to watch after the show you just finished.
                            Scripted shows from streaming services and broadcasters in {COVERAGE_COUNTRIES}.
                        </Typography>
                        <Typography variant="body" className="site-footer__mobile-summary text-foreground/80">
                            New TV, recommendations and archive search for {COVERAGE_COUNTRIES}.
                        </Typography>
                    </div>

                    <div className="footer-links">
                        <Typography as="p" variant="footer-heading" className="text-foreground/75">
                            Explore
                        </Typography>
                        <nav className="footer-links__nav">
                            <a className="footer-links__link" href="/archive">
                                Archive
                            </a>
                            <a className="footer-links__link" href="/most-recommended">
                                Recommendations
                            </a>
                            <a className="footer-links__link" href={`/best-of/${bestOfYearMonth}`}>
                                Best of {formatMonthLabel(bestOfYearMonth)}
                            </a>
                            <a className="footer-links__link" href="/about">
                                About
                            </a>
                            <a className="footer-links__link" href="/faq">
                                FAQ
                            </a>
                            <a className="footer-links__link" href="/privacy">
                                Privacy
                            </a>
                            <button className="footer-links__link text-left" type="button" onClick={openConsentPreferences}>
                                Analytics preferences
                            </button>
                        </nav>
                    </div>
            </div>
            <div className="site-footer__bottom">
                <span>© {year} PremiereLens</span>
                <span>New TV, recommendations with reasons, and archive search.</span>
            </div>
        </footer>
    );
};

export default SiteFooter;
